import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { PerimetersView } from '../../../components/group-steering/PerimetersView'

export const Route = createFileRoute('/$org/group/perimeters')({
    component: PerimetersRoute,
})

function PerimetersRoute() {
    const { org } = Route.useParams()
    const navigate = useNavigate()
    const search = useSearch({ from: '/$org/group' })
    const setSearch = (patch: Record<string, unknown>) =>
        navigate({ to: '/$org/group/perimeters', params: { org }, search: (prev: Record<string, unknown>) => ({ ...prev, ...patch }) as never, replace: true })
    return (
        <PerimetersView
            org={org}
            period={search.period ?? '90d'}
            level={search.level ?? 'agency'}
            family={search.family ?? 'requests'}
            selected={search.selected}
            q={search.q ?? ''}
            onSelect={(selected) => setSearch({ selected })}
            onQuery={(q) => setSearch({ q: q || undefined })}
            onFamilyChange={(family) => setSearch({ family })}
        />
    )
}
